import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import './css/Counter.css'

import {
  onStartDesign, onPause
} from './../actions/app'

import { PAUSE_DURATION } from './../reducers/app'
const message = (step) => {
  switch (step) {
    case 1:
        return 'We have recieve your email.'
    case 2:
        return 'Let design be with you.'
    case 3:
        return 'Hurra, great job we hope.'
    case 4:
        return 'You have 5 min, to attach your designs'
  
    default:
      return 'We have recieve your email.'
  }
}

const button = (step, paused, pauseDuration) => {
  switch (step) {
    case 1:
        return 'I want to Start Designing'
    case 2:
        return `${ paused ? 'Paused' : 'Pause'} (Only can pause ${pauseDuration} minutes in total)`
  
    default:
      return 'I want to Start Designing'
  }
}

const Counter = ({ step, counter, onStartDesign, onPause, paused, leftPause, pauseMinutes, hours, pauseDuration }) => (
  <section className="Counter">
    <h2>{message(step)}</h2>
    { step < 4 && <p className={`${step > 2 ? 'hidden' : ''}`}>Now show us what you can do.</p> }
    { step < 5 && <div className={`hour_${hours}`}>{step !== 3 ? `${step === 1 ? '2:00’00' : counter }` : '0:00’00'}</div> }
    { step < 3 && <button disabled={step === 2 && leftPause <= 0}
      onClick={(step <= 1 || paused) ? onStartDesign : onPause} 
      data-message={step === 2 ? `You have already use ${ pauseDuration - pauseMinutes } minutes of pause, you still have ${ pauseMinutes } more` : ''}
      >{ button(step, paused, pauseDuration) }</button> }
  </section>
)


const mapStateToProps = ({ app: { counter, paused, leftPause, pauseMinutes, hours } }) => {
  const pauseDuration = new Date(PAUSE_DURATION)
  return {
  counter, paused, leftPause, pauseMinutes, hours, pauseDuration: pauseDuration.getMinutes()
}}

const mapDispatchToProps = dispatch => bindActionCreators({
  onStartDesign, onPause
}, dispatch)

export default connect(
  mapStateToProps, mapDispatchToProps
)(Counter)


// WEBPACK FOOTER //
// ./src/containers/Counter.js